import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Consulting from "@/pages/Consulting";
import Services from "@/pages/Services";

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-right"
        theme="dark"
        richColors
        closeButton
        toastOptions={{
          style: {
            background: "rgba(10,10,10,0.92)",
            border: "1px solid rgba(243,215,137,0.25)",
            color: "#f5f5f5",
            backdropFilter: "blur(10px)",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/consulting" element={<Consulting />} />
          <Route path="/services" element={<Services />} />
          {/* About & Contact aren't separate pages in this MVP — gracefully redirect */}
          <Route path="/about" element={<Navigate to="/" replace />} />
          <Route path="/contact" element={<Navigate to="/consulting" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
